const CustomerJourneyDataMock = {
  hotel: {
    'id': '9e5d3c26bf66b76e6dea974930991627b4f9b497',
    'ta_id': '1001',
    'customer_journey_status': 'active', // active passed not_active
    'template': 'WHElite', // BWCore BWMain BWPlus BWPremier BWPremierCollection BWSignatureCollection BWSureHotelCollection WHDistinctive BWAiden WHCrafted WHElite
    'name': 'BW Premier BHR Treviso Hotel ---test',
    'picture': 'https://media-cdn.tripadvisor.com/media/photo-s/0a/7a/b5/ec/hall-1.jpg',
    'text': '"Qui trovi tutto ciò che ti serve per vivere un soggiorno straordinario: qualità, cura dei dettagli e un’accoglienza personalizzata."',
    'role': 'Reception IT',
    'signature': 'Firma IT',
    'lat': 41.92341,
    'lon': 12.46875,
    'address': 'Via Principe Amedeo 5/B',
    'city': 'Roma',
    'stars': '5',
    'zip': '59100',
    'email': 'email@hotel.com',
    'phone': '055 1231234',
    /*"additional_cards": []*/
    'additional_cards': [
      {
        'title': 'Matrimonio EN',
        'text': 'MatEn',
        'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/customer_journey/bestwestern/brand_contents/local/matrimonio.jpg',
        'link': 'http://www.facebook.com/'
      },
      {
        'title': 'Prova 3',
        'text': 'Bella la descrizione',
        'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/customer_journey/bestwestern/brand_contents/local/matrimonio.jpg',
        'link': 'http://www.facebook.com/'
      }
    ]
  },
  reservation: {
    'id': 'aec46cba77c',
    'first_name': 'Travel',
    'last_name': 'Bini',
    'checkin_date': 1511427600,
    'checkout_date': 1512219600,
    'timezone': 'Europe/Rome',
    'utc_displacement': '+1',
    'checkin_online': {
      'enabled': true,
      'done': false,
      'link': 'https://book.bestwestern.it/webcheckin/?hotel_BWid=98091&guest_firstname=Per&guest_lastname=Jenn%C3%83%C2%A9us&guest_language=IT&reservation_code=aec46cba77c&reservation_type=BW&reservation_arrivalDate=2017-11-23&reservation_departureDate=2017-12-02&reservation_nrAdults=2&reservation_nrChildren=1&email=alberto.bini%40travelappeal.com&guest_address=%C3%83%3Fnestadsgatan+24&guest_zip=587+23&guest_city=Link%C3%83%C2%B6ping&guest_country=IT'
    },
    'bot': {
      'enabled': true, // true | false
      'page_id': '1950302945190022', // "1779828612346402",
      'app_id': '1823869924520180', // "1838318073075365",
      'referral': '6a4.aec46cba77c9c',
      'link': 'http://m.me/1779828612346402?ref=6a4.aec46cba77c9c'
    },
    "contact_method": "whatsapp", // whatsapp | bot
    "whatsapp": {
      "enabled": true, // true | false
      "link": "https://wa.me/message/ZPQDW3QOJWKOL1"
    },
    'affiliation': {
      'affiliated': false, // true | false
      'link': 'https://book.bestwestern.it/BWR/RegistrazioneBwr.aspx?Nome=Travel&Cognome=Bini&Email=alberto.bini@travelappeal.com&utm_campaign=bestfriend&utm_content=BWR&utm_medium=chatbot&utm_source=facebook&sob=a136'
    },
    'mail_subscription_active': true
  },
  categories: [
    {
      'id': '452cb8d1-9924-4093-b8bf-a2a33ab26773',
      'name': 'Cheviaggiatoresei?',
      'image': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/bw_categories/che_viaggiatore_sei.png',
      'placeholder': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/bw_categories/che_viaggiatore_sei.png'
    },
    {
      'id': '5883c0b3-b78a-48f5-987b-ab9bf40a2fb4',
      'name': 'Cortesia&Comfort',
      'image': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/bw_categories/courtesy.png',
      'placeholder': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/bw_categories/courtesy.png'
    },
    {
      'id': '5883c0b3-b78a-48f5-987b-ab9bf40a2fb5',
      'name': 'Food&Drink',
      'image': 'https://placeholdit.imgix.net/~text?w=256&h=256',
      'placeholder': 'https://placeholdit.imgix.net/~text?w=64&h=64'
    }
  ],
  eventCategories: [
    {
      'id': 'v:1',
      'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/musement/art_musei.png',
      'name': 'Museums & art'
    },
    {
      'id': 'v:2',
      'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/musement/tour.png',
      'name': 'Tours & attractions'
    },
    {
      'id': 'v:4',
      'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/musement/concerti.png',
      'name': 'Performances'
    },
    {
      'id': 'v:3',
      'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/musement/food_wine.png',
      'name': 'Food & wine'
    },
    {
      'id': 'v:6',
      'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/musement/sports_.png',
      'name': 'Active & adventure'
    },
    {
      'id': null,
      'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/musement/popular_.png',
      'name': 'Most   popular'
    }
  ],
  eventCategory: [
    {
      'id': 776,
      'name': 'Tour   salta   fila   di   Musei   Vaticani,   S.   Pietro   e   Cappella Sistina...',
      'price': 60,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/67/thumb_66219_cover_header.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/tour-salta-fila-di-musei-vaticani-s-pietro-e-cappella-sistina-776/',
      'latitude': 41.907,
      'longitude': 12.453,
      'description': 'Scopri   le   bellezze   del   Vaticano   con   una   guida esperta...',
      'discount_price': 45
    },
    {
      'id': 512,
      'name': 'Biglietti   salta   fila   per   Musei   Vaticani   e   Cappella Sistina...',
      'price': 0,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/06/vatican-museums-and-sistine-chapel-skip-the-line-tickets_header-5714.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/biglietti-salta-fila-per-musei-vaticani-e-cappella-sistina-512/',
      'latitude': 41.906759,
      'longitude': 12.4535,
      'description': 'Salta   le   lunghe   code   che   affollano   i   Vaticani...'
    },
    {
      'id': 773,
      'name': 'Tour   della   Roma   Antica   con   ingresso   salta   fila   al   Colosseo, Foro   Romano   e   Pal...',
      'price': 50,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/19/colosseum-roman-forum-and-palatine-hill-skip-the-line-tickets-and-tour_header-18745.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/tour-della-roma-antica-con-ingresso-salta-fila-a-colosseo-foro-romano-e-palatino-773/',
      'latitude': 41.89171,
      'longitude': 12.491599,
      'description': 'Visita   il   simbolo   più   importante   di   Roma,   saltando   la coda...',
      'discount_price': 29.99
    },
    {
      'id': 4379,
      'name': 'Tour   completo   salta   fila   del   meglio   del   Vaticano   per   piccoli gruppi...',
      'price': 69,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/23/vatican-museums-guided-group-tour-max-15-people_header-22652.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/tour-completo-salta-fila-del-meglio-del-vaticano-per-piccoli-gruppi-4379/',
      'latitude': 41.902916,
      'longitude': 12.453389,
      'description': 'Risparmia   tempo!   Salta   la   fila,   biglietto   d\'ingresso incluso...',
      'discount_price': 0
    },
    {
      'id': 4886,
      'name': 'Antica   Roma:   tour   dei   sotterranei   e   della   città   nascosta   per piccoli   gruppi...',
      'price': 35,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/28/ancient-rome-what-lies-beneath-walking-tour_header-27061.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/antica-roma-tour-dei-sotterranei-e-della-citta-nascosta-per-piccoli-gruppi-4886/',
      'latitude': 41.89898,
      'longitude': 12.47286,
      'description': 'Esplora   i   siti   segreti   sotto   le   strade   di   Roma...'
    },
    {
      'id': 10709,
      'name': 'Tour   privato   esclusivo   in   Vaticano...', 'price': 350,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/70/thumb_69919_cover_header.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/tour-privato-esclusivo-in-vaticano-10709/',
      'latitude': 41.9074592,
      'longitude': 12.456057,
      'description': 'Goditi   l\'ingresso   privilegiato   e   ammira   il   meglio   dei Musei   Vaticani,   Cappell...'
    },
    {
      'id': 5358,
      'name': 'Tour   a   piedi   delle   basiliche   sotterranee   di   Roma   e   del   Foro Boario...',
      'price': 35,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/31/rome-underground-basilicas-foro-boario-walking-tour_header-30308.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/tour-a-piedi-delle-basiliche-sotterranee-di-roma-e-del-foro-boario-5358/',
      'latitude': 41.889115,
      'longitude': 12.480365,
      'description': 'Scopri   due   basiliche   sotterranee   nel   cuore   di Roma...'

    },
    {
      'id': 7981,
      'name': 'Biglietti   e   visita   guidata   di   "Cinecittà   si   mostra"...',
      'price': 14,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/48/thumb_47118_cover_header.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/biglietti-e-visita-guidata-di-cinecitta-si-mostra-7981/',
      'latitude': 41.84956,
      'longitude': 12.574408,
      'description': 'Scopri   il   dietro   le   quinte   di   tanti   film famosissimi...',
      'discount_price': null

    },
    {
      'id': 7986,
      'name': 'Galleria   Spada:   biglietti   d\'ingresso...',
      'price': 9,
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/48/galleria-spada-roma_header-47364.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/galleria-spada-biglietti-d-ingresso-7986/',
      'latitude': 41.894417,
      'longitude': 12.471714,
      'description': 'Visita   Palazzo   Spada   con   l\'omonima   Galleria...'
    },
    {
      'id': 8150,
      'name': 'Biglietti   Musei   Vaticani   con   accesso   prioritario esclusivo...',
      'price': 'gratis',
      'currency': 'EUR',
      'picture': 'https://images.musement.com/cover/0001/49/thumb_48235_cover_header.jpeg?w=540',
      'link': 'https://www.musement.com/it/roma/biglietti-musei-vaticani-con-accesso-prioritario-esclusivo-8150/',
      'latitude': 41.907262,
      'longitude': 12.45304,
      'description': 'Grazie   al   nostro   Accesso   "No   wait"   (senza   attesa), potrai   saltare   le   lunghe   f...'
    }
  ],
  attractions: [
    {
      'place_id': 'ChIJOWqsvIo2eUcRbA72LSaviwI',
      'name': 'OpenDream - Area Ex Pagnossin',
      'address': 'Via Noalese, 115-117, 31100 Quinto TV, Italy',
      'rating': 5,
      'phone': null,
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipN6M0vl3wU3gwFD9tHF9yFtt51d3sODiLBkWGwH=s1600-w676',
      'latitude': 45.6512955,
      'longitude': 12.1878961
    },
    {
      'place_id': 'ChIJjcMqg5Y2eUcRppmsRQTT3DM',
      'name': 'Biblioteca Comunale',
      'address': 'Via G. D\'Annunzio, 9, 31055 Quinto di Treviso TV, Italy',
      'rating': 4.5,
      'phone': '+39 0422 472336',
      'picture': 'http://via.placeholder.com/150x350',
      'latitude': 45.6473185,
      'longitude': 12.1659239
    },
    {
      'place_id': 'ChIJ_UVjZBlIeUcRbt6VfD0h088',
      'name': 'Parco dello Storga - ingresso ovest',
      'address': 'Via Cal di Breda, 31100 Treviso TV, Italy',
      'rating': null,
      'phone': '+39 0422 656746',
      'picture': 'http://via.placeholder.com/150x350',
      'latitude': 45.6870156,
      'longitude': 12.262244
    },
    {
      'place_id': 'ChIJ7TSABtU3eUcRmNMwMT555Lo',
      'name': 'Galleria L\'Elefante Di Cesare Misserotti',
      'address': 'Via Roggia, 52, 31100 Treviso TV, Italy',
      'rating': 5,
      'phone': '+39 0422 419550',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipPF0qewcxehei0taGi5XlL4xCp-h-wpMq_kjneh=s1600-w900',
      'latitude': 45.6677588,
      'longitude': 12.2434466
    },
    {
      'place_id': 'ChIJ8Wy3hWpJeUcRA-YaGHKWpX8',
      'name': 'Sile River Regional Park',
      'address': 'Via Alessandro e Luigino Tandura, 40, 31100 Treviso TV, Italy',
      'rating': 4.5,
      'phone': '+39 0422 321994',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipO0U7jwe7wTXIqPJdk1CWHjrSJYAR7YOOqvCyQ=s1600-w900',
      'latitude': 45.6598604,
      'longitude': 12.2234298
    },
    {
      'place_id': 'ChIJk6V5jEw0eUcRzCZaKESzioE',
      'name': 'Biblioteca Comunale G. Cozzi di Zero Branco',
      'address': 'Via G. B. Guidini, 52, 31059 Zero Branco TV, Italy',
      'rating': 5,
      'phone': '+39 0422 485518',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipP96W7eCRxda5x6nZl74moWagymzQhD4zYInMKS=s1600-w900',
      'latitude': 45.6080319,
      'longitude': 12.1815292
    },
    {
      'place_id': 'ChIJ_byA79o5eUcR0Kzz2dSL6aQ',
      'name': 'Biblioteca Civica',
      'address': 'Via Giovanni Battista Cicogna, 45, 31050 Ponzano Veneto TV, Italy',
      'rating': 4.7,
      'phone': '+39 0422 960329',
      'picture': 'http://via.placeholder.com/150x350',
      'latitude': 45.7164149,
      'longitude': 12.2027436
    },
    {
      'place_id': 'ChIJgbbnY9M3eUcRw3vEQ9Y-O1I',
      'name': 'Biblioteca dei Ragazzi E. Demattè',
      'address': 'Piazza Rinaldi, 1/b, 31100 Treviso TV, Italy',
      'rating': 4.3,
      'phone': '+39 0422 658993',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipPECSSCRtIKePloBd_cJQ80VEJwPFqeKlwclkId=s1600-w900',
      'latitude': 45.6682555,
      'longitude': 12.2463106
    },
    {
      'place_id': 'ChIJgbbnY9M3eUcRWwJhnOdvYtg',
      'name': 'Biblioteca di Città Giardino \'Andrea Zanzotto\'',
      'address': 'Via Luigi Giacomelli, 10, 31100 Treviso TV, Italy',
      'rating': 4.1,
      'phone': '+39 0422 410840',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipNCGz-0f-vgMsWSvpeBV-HOTKNdpGx9m2OTJM88=s1600-w900',
      'latitude': 45.6660267,
      'longitude': 12.2381573
    },
    {
      'place_id': 'ChIJVVVVVS43eUcRSYQ13VboDpQ',
      'name': 'Biblioteca',
      'address': 'Viale Bernardino Panizza, 6, 31038 Paese TV, Italy',
      'rating': 4.7,
      'phone': '+39 0422 959003',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipNOz5F047Ns4mP7lFknbQgIzxMhNlqVFWRObPH3=s1600-w900',
      'latitude': 45.68033,
      'longitude': 12.159057
    }
  ],
  menu: {
    'breakfast': {
      'start': '06:30',
      'end': '09:30',
      'description': 'Al   primo   piano   dell\'hotel. http://maps.google.it/ https://www.google.it/maps/place/Best+Western+Plus+CHC+Florence/@43.7803705,11.2206103,14z/data=!4m8!1m2!2m1!1sbest+western+fireze!3m4!1s0x132a56e1b9e880c1:0x8b971ca9ff9d0f88!8m2!3d43.7943213!4d11.208795',
      'menu': [
        'Colazione   internazionale',
        'http://www.bhrtrevisohotel.com/wp-content/uploads/2017/07/menu-divino-osteria-trevigiana-estate-2017_selezione.pdf ',
        'http://www.bhrtrevisohotel.com/wp-content/uploads/2017/08/20170821_Carta-vini-2017_ok.pdf'
      ],
      'image': 'https://s3.eu-west-1.amazonaws.com/staticta/customer_journey/breakfast.png'
    },
    'lunch': {
      'start': '12:00',
      'end': '14:00',
      'description': 'In   terrazza   dell\'hotel',
      'menu': [
        'Buffet antipasti',
        'Spaghetti al pomodoro',
        'Cotoletta alla milanese',
        'Dolci alla carta'
      ],
      'image': 'https://s3.eu-west-1.amazonaws.com/staticta/customer_journey/lunch.png'
    },
    'dinner': {
      'start': '18:00',
      'end': '21:00',
      'description': 'Al secondo piano dell\'hotel',
      'menu': [
        'Buffet antipasti',
        'Spaghetti allo scoglio',
        'Trancio di salmone',
        'Dolci alla carta'
      ],
      'image': 'https://s3.eu-west-1.amazonaws.com/staticta/customer_journey/dinner.png'
    },
    'extra': 'Donec varius mollis tellus a semper. Curabitur urna odio, viverra et condimentum eget, finibus at ex. Cras nec tortor quis nunc sodales interdum.'
  },
  venues: [
    {
      'place_id': 'ChIJedMXEeM2eUcRcQYrPPqUsaw',
      'name': 'DiVino Osteria Trevigiana',
      'address': 'Best Western Premier BHR Treviso Hotel, Via Postumia Castellana, 2, 31055 Quinto di Treviso TV, Italy',
      'rating': 5,
      'phone': '+39 0422 373710',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipNsBX0NLGtUyKXcXCQWJ7p20_QW7sXEdpYW6MHa=s1600-w765',
      'latitude': 45.6683924,
      'longitude': 12.1800209
    },
    {
      'place_id': 'ChIJeSudQ1U2eUcRMholxaPSQ14',
      'name': 'Lago Di Ponzano',
      'address': 'Strada di Sovernigo Porcellengo, 7, 31100 Treviso TV,Italy',
      'rating': null,
      'phone': '+39 0422 22063',
      'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/placeholder_restaurant.png',
      'latitude': 45.6698136,
      'longitude': 12.1971795
    },
    {
      'place_id': 'ChIJ1XakZyg3eUcRyr-tYXMBT6s',
      'name': 'Da Poli Trattoria',
      'address': 'via 31038, Via Roma, 68, 31038 Paese TV, Italy',
      'rating': null,
      'phone': null,
      'picture': 'https://s3-eu-west-1.amazonaws.com/staticta/chatbot/bestwestern/placeholder_restaurant.png',
      'latitude': 45.6762577,
      'longitude': 12.1607729
    },
    {
      'place_id': 'ChIJdcv2Zig3eUcRZtngWlLi0sw',
      'name': 'Ristorante Pizzeria Gelateria Polin',
      'address': 'Via Roma, 66, 31038 Paese TV, Italy',
      'rating': 3.9,
      'phone': '+39 0422 951288',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipObwBji3AHNJ3U7_72BN9Ns3e7Wp0c-igDvuLaQ=s1600-w900',
      'latitude': 45.6760903,
      'longitude': 12.1608205
    },
    {
      'place_id': 'ChIJl4CUd9c2eUcRlit8u91kTeU',
      'name': 'Trattoria Tre Stelle Di Favero Alessandra',
      'address': 'Via Postumia, 110, 31038 Paese TV, Italy',
      'rating': 3.5,
      'phone': '+39 0422 959302',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipMZ4B3rFSeUb-p-6XrNV8jN793d-DQxAfNWeJNl=s1600-w900',
      'latitude': 45.6719795,
      'longitude': 12.1594996
    },
    {
      'place_id': 'ChIJ_yIShiY3eUcR-RkJRnXG8AE',
      'name': 'Al Ghiottone',
      'address': 'Via Resistenza, 14, 31038 Paese TV, Italy',
      'rating': 4.3,
      'phone': '+39 0422 958401',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipPZfuA4pWNg_qW63vo9bj6kepx0LoTbHVOPHpx8=s1600-w900',
      'latitude': 45.6780732,
      'longitude': 12.1657508
    },
    {
      'place_id': 'ChIJhRuL-SY3eUcR04FsHENY4Is',
      'name': 'DOC Kabab',
      'address': 'Via della Resistenza, 44, 31038 Paese TV, Italy',
      'rating': 4.6,
      'phone': '+39 333 242 0739',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipPl7H8kUvMhjQbeDkULN_OW281Kq13ul6sY5Uxi=s1600-w900',
      'latitude': 45.6767017,
      'longitude': 12.1658741
    },
    {
      'place_id': 'ChIJl_9pVi43eUcRuu9H9xo0A9g',
      'name': 'El Paninaro de tutti i di',
      'address': 'Via Stazione, 31038 Paese TV, Italy',
      'rating': 4.8,
      'phone': '+39 327 493 1514',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipNnp8PUpq6BESZRx4WR0OI-uFFVIa3kabMPxbI=s1600-w900',
      'latitude': 45.6718594,
      'longitude': 12.162509
    },
    {
      'place_id': 'ChIJq59I0f82eUcROVFaQSv5ngk',
      'name': 'Al Laghetto',
      'address': 'Via Sovernigo, 7/A, 31100 Treviso TV, Italy',
      'rating': 4.1,
      'phone': '+39 0422 22063',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipNpmAFEXm-46caQt3y-bsPBfdxW-9y_25PmeUrx=s1600-w900',
      'latitude': 45.6697972,
      'longitude': 12.1973033
    },
    {
      'place_id': 'ChIJkwqZm9g2eUcRdvp4dl1S6ug',
      'name': 'Al Granaio di Franco e Mauro Ristorante',
      'address': 'Piazza Quaglia, 20, 31038 Paese TV, Italy',
      'rating': 4.1,
      'phone': '+39 0422 456076',
      'picture': 'https://lh3.googleusercontent.com/p/AF1QipMIShS3LABCbDltE97exhYjfrHwl0M6hHmy96k4=s1600-w632',
      'latitude': 45.6735031,
      'longitude': 12.1651268
    }
  ],
  services: [
    {
      'id': '37f8fe05-08e6-463d-be20-a55400c331f7',
      'name': 'Pacchetto BU$INESS e trasporto dall\'aeroporto',
      'payment_type': 'Pagamento in Hotel',
      'price': 10,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/3f663da3-b514-4adb-8fc0-f0ebe1916580/it/PLI/pacchetto-business.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati a chi viaggia per lavoro: Kit di cortesia con prodotti di marca, Bollitore per tè e caffè, Servizio in camera, Quotidiano, Uso di fax, stampante e fotocopiatrice, Lap tray: supporto per PC portatile, Caffè gratuiti presso il nostro American Bar',
      'status': 'available'
    },
    {
      'id': '1edb4c82-29df-4d2b-88ba-a55400c6b99c',
      'name': 'Pacchetto WOMAN',
      'payment_type': 'Pagamento in Hotel',
      'price': null,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/0aa34168-0804-4a6b-9d25-8e9cd5a6c50d/it/PLI/pacchetto-woman.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati alle donne che viaggiano per lavoro o per vacanza: Kit cortesia con prodotti di marca, Phon professionale e piastra per capelli, Bollitore in camera con selezione di tè e di tisane, Servizio in camera, Magazine femminile, Caffè gratuiti presso il nostro American Bar',
      'status': 'wait_response'
    },
    {
      'id': '9923cd36-68ec-4268-b9e8-a54d00d476c3',
      'name': 'Pacchetto KIDS',
      'payment_type': 'Pagamento in Hotel',
      'price': 10,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/fec66ea5-16f8-4201-b744-251182ac0fce/it/PLI/pacchetto-kids.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati alle famiglie che viaggiano con i bambini: Sony Playstation® 3 con i giochi più divertenti, TV LED FULL HD con Sky e canali per bambini, 1 gettone per la lavatrice a soggiorno',
      'status': 'available'
    },
    {
      'id': '1edb4c82-29df-4d2b-88ba-a55400c6b100',
      'name': 'Pacchetto WOMAN',
      'payment_type': 'Pagamento in Hotel',
      'price': 0,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/0aa34168-0804-4a6b-9d25-8e9cd5a6c50d/it/PLI/pacchetto-woman.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati alle donne che viaggiano per lavoro o per vacanza: Kit cortesia con prodotti di marca, Phon professionale e piastra per capelli, Bollitore in camera con selezione di tè e di tisane, Servizio in camera, Magazine femminile, Caffè gratuiti presso il nostro American Bar',
      'status': 'available'
    },
    {
      'id': '9923cd36-68ec-4268-b9e8-a54d00d47101',
      'name': 'Pacchetto KIDS',
      'payment_type': 'Pagamento in Hotel',
      'price': 35,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/fec66ea5-16f8-4201-b744-251182ac0fce/it/PLI/pacchetto-kids.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati alle famiglie che viaggiano con i bambini: Sony Playstation® 3 con i giochi più divertenti, TV LED FULL HD con Sky e canali per bambini, 1 gettone per la lavatrice a soggiorno',
      'status': 'booked'
    },
    {
      'id': '37f8fe05-08e6-463d-be20-a55400c331fas',
      'name': 'Pacchetto BU$INESS',
      'payment_type': 'Pagamento in Hotel',
      'price': 10,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/3f663da3-b514-4adb-8fc0-f0ebe1916580/it/PLI/pacchetto-business.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati a chi viaggia per lavoro: Kit di cortesia con prodotti di marca, Bollitore per tè e caffè, Servizio in camera, Quotidiano, Uso di fax, stampante e fotocopiatrice, Lap tray: supporto per PC portatile, Caffè gratuiti presso il nostro American Bar',
      'status': 'available'
    },
    {
      'id': '1edb4c82-29df-4d2b-88ba-a55400c6b99ad',
      'name': 'Pacchetto WOMAN',
      'payment_type': 'Pagamento in Hotel',
      'price': null,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/0aa34168-0804-4a6b-9d25-8e9cd5a6c50d/it/PLI/pacchetto-woman.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati alle donne che viaggiano per lavoro o per vacanza: Kit cortesia con prodotti di marca, Phon professionale e piastra per capelli, Bollitore in camera con selezione di tè e di tisane, Servizio in camera, Magazine femminile, Caffè gratuiti presso il nostro American Bar',
      'status': 'available'
    },
    {
      'id': '9923cd36-68ec-4268-b9e8-a54d00d476caf',
      'name': 'Pacchetto KIDS',
      'payment_type': 'Pagamento in Hotel',
      'price': 10,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/fec66ea5-16f8-4201-b744-251182ac0fce/it/PLI/pacchetto-kids.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati alle famiglie che viaggiano con i bambini: Sony Playstation® 3 con i giochi più divertenti, TV LED FULL HD con Sky e canali per bambini, 1 gettone per la lavatrice a soggiorno',
      'status': 'available'
    },
    {
      'id': '1edb4c82-29df-4d2b-88ba-a55400c6b10ah',
      'name': 'Pacchetto WOMAN',
      'payment_type': 'Pagamento in Hotel',
      'price': 0,
      'currency': 'EUR',
      'picture':
        'https://book.hotelres.it/resources/images/189/0aa34168-0804-4a6b-9d25-8e9cd5a6c50d/it/PLI/pacchetto-woman.jpg',
      'description': 'Aggiungi al tuo soggiorno i nostri servizi dedicati alle donne che viaggiano per lavoro o per vacanza: Kit cortesia con prodotti di marca, Phon professionale e piastra per capelli, Bollitore in camera con selezione di tè e di tisane, Servizio in camera, Magazine femminile, Caffè gratuiti presso il nostro American Bar',
      'status': 'available'
    }
  ],
  weather: {
    '20171208': {
      't_max': 14.87,
      't_min': 7.7,
      'unit': 'CELSIUS',
      'desc': 'partly-cloudy-day', //clear-day, clear-night, rain, snow, sleet, wind, fog, cloudy, partly-cloudy-day, or partly-cloudy-night
      'image': 'http://via.placeholder.com/50x50'
    },
    '20171209': {
      't_max': 13.43,
      't_min': 1.6,
      'unit': 'CELSIUS',
      'desc': 'partly-cloudy-day',
      'image': 'http://via.placeholder.com/50x50'
    },
    '20171210': {
      't_max': 14.34,
      't_min': -1.2,
      'unit': 'CELSIUS',
      'desc': 'partly-cloudy-night',
      'image': 'http://via.placeholder.com/50x50'
    },
    '20171211': {
      't_max': 17.48,
      't_min': 13.79,
      'unit': 'CELSIUS',
      'desc': 'wind',
      'image': 'http://via.placeholder.com/50x50'
    },
    '20171212': {
      't_max': 17.29,
      't_min': 11.83,
      'unit': 'CELSIUS',
      'desc': 'wind',
      'image': 'http://via.placeholder.com/50x50'
    },
    '20171213': {
      't_max': 14.31,
      't_min': 10.82,
      'unit': 'CELSIUS',
      'desc': 'rain',
      'image': 'http://via.placeholder.com/50x50'
    },
    '20171214': {
      't_max': 14.32,
      't_min': 10.84,
      'unit': 'CELSIUS',
      'desc': 'rain',
      'image': 'http://via.placeholder.com/50x50'
    },
    '20171215': {
      't_max': 12.17,
      't_min': 10.47,
      'unit': 'CELSIUS',
      'desc': 'rain',
      'image': 'http://via.placeholder.com/50x50'
    }
  },
  newsCategories: [
    {
      'id': 'news',
      'picture': 'https:\/\/s3-eu-west-1.amazonaws.com\/staticta\/chatbot\/bestwestern\/newsfeed\/news.png',
      'name': 'News'
    },
    {
      'id': 'entertainment',
      'picture': 'https:\/\/s3-eu-west-1.amazonaws.com\/staticta\/chatbot\/bestwestern\/newsfeed\/entertainment.png',
      'name': 'Entertainment'
    },
    {
      'id': 'sports',
      'picture': 'https:\/\/s3-eu-west-1.amazonaws.com\/staticta\/chatbot\/bestwestern\/newsfeed\/sports.png',
      'name': 'Sport'
    },
    {
      'id': 'money',
      'picture': 'https:\/\/s3-eu-west-1.amazonaws.com\/staticta\/chatbot\/bestwestern\/newsfeed\/money.png',
      'name': 'Economy'
    },
    {
      'id': 'lifestyle',
      'picture': 'https:\/\/s3-eu-west-1.amazonaws.com\/staticta\/chatbot\/bestwestern\/newsfeed\/lifestyle.png',
      'name': 'Lifestyle'
    },
    {
      'id': 'health',
      'picture': 'https:\/\/s3-eu-west-1.amazonaws.com\/staticta\/chatbot\/bestwestern\/newsfeed\/health.png',
      'name': 'Health and wellness'
    },
    {
      'id': 'video',
      'picture': 'https:\/\/s3-eu-west-1.amazonaws.com\/staticta\/chatbot\/bestwestern\/newsfeed\/video.png',
      'name': 'Video'
    }
  ],
  newsCategory: [
    {
      'id': 'BBVmiz2',
      'link': 'https:\/\/www.msn.com\/en-us\/news\/politics\/the-russian-hoax-is-finally-dead-trump-tells-michigan-rally\/ar-BBVmiz2?ocid=BWItaly',
      'title': '\u2018The Russian Hoax Is Finally Dead,\u2019 Trump Tells Michigan Rally',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVmSR0.img',
      'content': 'President Trump, fresh off what he claims was \u201ctotal vindication\u201d in the special counsel\u2019s Russia investigation, told supporters here Thursday he had vanquished a corrupt cabal of Democrats, the news media and the Washington elite, who tried to nullify his historic election victory by painting him as an agent of Russia.',
      'publishDate': '2019-03-29T02:38:45.000+0000',
      'categories': [
        'NEWS'
      ],
      'tags': [
        'Politics',
        'News',
        'Russia',
        'Donald Trump'
      ],
      'provider_name': 'The New York Times',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AAvpBp.img'
    },
    {
      'id': 'BBVmQqV',
      'link': 'https:\/\/www.msn.com\/en-us\/news\/us\/court-deals-trump-second-blow-this-week-on-health-care\/ar-BBVmQqV?ocid=BWItaly',
      'title': 'Court deals Trump second blow this week on health care',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVmWKU.img',
      'content': 'A federal judge on Thursday struck down a Trump administration rule that allows small businesses to band together and set up health insurance plans that skirt requirements of the Affordable Care Act.',
      'publishDate': '2019-03-29T03:56:03.000+0000',
      'categories': [
        'NEWS'
      ],
      'tags': [
        'US News',
        'News',
        'Health Care Industry'
      ],
      'provider_name': 'The New York Times',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AAvpBp.img'
    },
    {
      'id': 'BBVlVQe',
      'link': 'https:\/\/www.msn.com\/en-us\/news\/factcheck\/ap-fact-check-trump-s-fabrications-on-autos-health-care\/ar-BBVlVQe?ocid=BWItaly',
      'title': 'AP FACT CHECK: Trump\'s fabrications on autos, health care',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVmCK7.img',
      'content': 'Rallying in Michigan, President Donald Trump bragged Thursday night about a surging auto industry that isn\'t surging, a Republican rescue for health care that has yet to take shape, a "total" exoneration in the Russia investigation that was not offered.And Trump, as he routinely does, took credit for a veterans health care initiative that...',
      'publishDate': '2019-03-29T01:44:00.000+0000',
      'categories': [
        'NEWS'
      ],
      'tags': [
        'News',
        'Politics',
        'Health Care Industry'
      ],
      'provider_name': 'Associated Press',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AAy3rxw.img'
    },
    {
      'id': 'BBVmFFd',
      'link': 'https:\/\/www.msn.com\/en-us\/sports\/ncaabk\/purdue-outlasts-tennessee-99-94-in-ot\/ar-BBVmFFd?ocid=BWItaly',
      'title': 'Purdue outlasts Tennessee 99-94 in OT',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVmS5C.img',
      'content': null,
      'publishDate': '2019-03-29T02:02:09.000+0000',
      'categories': [
        'SPORTS'
      ],
      'tags': [
        'NCAA Basketball',
        'Sports',
        'Tenessee'
      ],
      'provider_name': 'Associated Press',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AAy3rxw.img'
    },
    {
      'id': 'BBVl3tb',
      'link': 'https:\/\/www.msn.com\/en-us\/news\/crime\/chicago-seeks-to-recoup-130-000-from-jussie-smollett-as-war-of-words-heats-up\/ar-BBVl3tb?ocid=BWItaly',
      'title': 'Chicago seeks to recoup $130,000 from Jussie Smollett as war of words heats up',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVl8jq.img',
      'content': 'The demand that \u201cEmpire\u201d actor Jussie Smollett pay Chicago back for an alleged hate crime hoax despite being cleared of criminal charges punctuated an increasingly shrill war of words Thursday that stretched to the White House and New York. The day began with President Donald Trump tweeting that the U.S. Department of Justice and FBI were \u201cto review\u201d what happened in the Smollett investigation, which ended in stunning fashion Tuesday when Cook...',
      'publishDate': '2019-03-29T01:16:53.000+0000',
      'categories': [
        'NEWS'
      ],
      'tags': [
        'Chicago'
      ],
      'provider_name': 'Chicago Tribune',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AA60Ia9.img'
    },
    {
      'id': 'BBVmpBz',
      'link': 'https:\/\/www.msn.com\/en-us\/news\/us\/devos-reverses-course-on-special-olympics-cuts-after-trump-orders-funding\/ar-BBVmpBz?ocid=BWItaly',
      'title': 'DeVos reverses course on Special Olympics cuts after Trump orders funding',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVgPsZ.img',
      'content': 'Education Secretary Betsy DeVos spent three days defending her plan to eliminate Special Olympics funding from next year\'s budget.',
      'publishDate': '2019-03-29T02:10:00.000+0000',
      'categories': [
        'NEWS'
      ],
      'tags': [
        'Politics',
        'News',
        'Olympic Games',
        'Donald Trump'
      ],
      'provider_name': 'CNN',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AAxY5AI.img'
    },
    {
      'id': 'BBVmfP2',
      'link': 'https:\/\/www.msn.com\/en-us\/news\/politics\/a-mueller-mystery-how-trump-dodged-a-special-counsel-interview-and-a-subpoena-fight\/ar-BBVmfP2?ocid=BWItaly',
      'title': 'A Mueller mystery: How Trump dodged a special counsel interview \u2014 and a subpoena fight',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVkAKG.img',
      'content': 'The president\u2019s legal team conducted an extensive pressure campaign to keep him from coming face-to-face with federal investigators \u2014 fearful he would perjure himself.',
      'publishDate': '2019-03-29T00:24:00.000+0000',
      'categories': [
        'NEWS'
      ],
      'tags': [
        'News',
        'Politics',
        'Donald Trump',
        'Job Interviews'
      ],
      'provider_name': 'The Washington Post',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AAxYtfi.img'
    },
    {
      'id': 'BBVjXKb',
      'link': 'https:\/\/www.msn.com\/en-us\/weather\/photos\/the-week-in-weather-march-29\/ss-BBVjXKb?ocid=BWItaly',
      'title': 'The week in weather: March 29',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVjZXu.img',
      'content': 'Incredible images of Mother Nature\'s highs and lows',
      'publishDate': '2019-03-29T07:30:00.000+0000',
      'categories': [
        'WEATHER',
        'NEWS'
      ],
      'tags': [
        'Weather'
      ],
      'provider_name': null,
      'provider_logo': null
    },
    {
      'id': 'BBVngve',
      'link': 'https:\/\/www.msn.com\/en-us\/music\/celebrity\/lil-wayne-pays-off-massive-14-million-tax-bill\/ar-BBVngve?ocid=BWItaly',
      'title': 'Lil Wayne Pays Off Massive $14 Million Tax Bill',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVndpS.img',
      'content': 'If you\u2019re nervous about cutting Uncle Sam a check this tax season, just remember it could be worse \u2014 you could be Lil Wayne.&nbsp;',
      'publishDate': '2019-03-29T07:30:00.000+0000',
      'categories': [
        'MUSIC'
      ],
      'tags': [
        'Music',
        'Entertainment',
        'Music',
        'Lil Wayne (musician)'
      ],
      'provider_name': 'The Blast',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AAAmgjS.img'
    },
    {
      'id': 'BBVmD3J',
      'link': 'https:\/\/www.msn.com\/en-us\/news\/politics\/paul-manafort-will-get-his-famous-jackets-returned\/ar-BBVmD3J?ocid=BWItaly',
      'title': 'Paul Manafort will get his famous jackets returned',
      'picture': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/BBVmNeg.img',
      'content': 'In the end, Paul Manafort gets to keep the python jacket and the ostrich vest.',
      'publishDate': '2019-03-29T02:54:22.000+0000',
      'categories': [
        'NEWS'
      ],
      'tags': [
        'News',
        'Politics',
        'Celebrities',
        'Paul George'
      ],
      'provider_name': 'CNN',
      'provider_logo': 'https:\/\/img-s-msn-com.akamaized.net\/tenant\/amp\/entityid\/AAxY5AI.img'
    }
  ],
  duringStaySurvey_getAnswer: {
    status: 'EXPIRED'
  },
  duringStaySurvey_sendAnswer: {
    status: 'DONE'
  }
};

export default CustomerJourneyDataMock;



// WEBPACK FOOTER //
// ./sources/mocks/data/CustomerJourneyDataMock.js